export default __webpack_public_path__ + "static/media/tablet-page-footer.ca3df638.jpg";